<script>
    import { createEventDispatcher } from 'svelte';
    import { selectedGroup } from "../store.js"
    import { Button } from 'sveltestrap';
    import { Link } from 'svelte-routing';
    import getLastReportedColour from '../Helpers/LastReportedStateHelper';
    import formatDate from '../Helpers/DateTimeFormatter';
    import http from '../api/http.js';
    import Prettysize from 'prettysize';
    import Tag from '../components/Tag.svelte';
    
    export let computer;
    export let showAttributes = false;
    export let uniqueAttributeNames = [];

    let columnSpan = 7; 
    let isExpanded = false;

    export let visibleColumns;

    $:{
        uniqueAttributeNames;
    }

    $:{
        visibleColumns;
        visibleColumns = visibleColumns;
    }

    let computerDetails = {
        computerId: 0,
        hostName: "",
        processor: "",
        deployVersion: "",
        memoryCapacity: "",
        memoryType: "",
        osName: "",
        osBuildNumber: "",
        osArchitecture: "",
        osLanguage: "",
        dnsHostName: "",
        partOfDomain: "",
        domain: "",
        workgroup: ""
    }

    let tag = {
        text: "",
        color: "",
        icon: ""
    }

    const dispatch = createEventDispatcher();
    
    let selectComputerAction = () => {
        dispatch('selectComputer');
	};

    let deleteComputerAction = () => {
        dispatch('deleteComputer');
    };

    function toggleExpand() {
        isExpanded = !isExpanded;
    }

    async function getComputerDetails(){
        const res = await http.get(`${window.apiBaseUrl}/deploy/dashboard/computers/spec/${computer.id}/${$selectedGroup}`);
        if (res.status == 200){
           computerDetails = await res.json();
        }
    }
    
    function getAttributeValue(computer, uniqueAttribute){
        let attribute = computer.attributes.filter(attr => attr.name == uniqueAttribute);
        if (attribute.length > 0){
            return attribute;
        }
        else {
            return "";
        }    
    }

    function handleTag(versionState){
        switch(versionState){
            case 0:
                tag.color = "info";
                tag.icon = "question-circle";
                break;
            case 1:
                tag.color = "danger";
                tag.icon = "fire";
                break;
            case 2:
                tag.color = "warning";
                tag.icon = "exclamation-triangle";
                break;
            case 3:
                tag.color = "success";
                tag.icon = "thumbs-up";
                break;
        }
    }

    $:{
        handleTag(computer.deployVersionState);
    }
</script>

<tr id="computer-row-{computer.hostName}{computer.vesselName}">
    <td><button class="dropdown-button {isExpanded ? "active" : ""}" on:click={()=> toggleExpand()}><i class="fa fa-chevron-{isExpanded ? "down" : "right"} "></i></button></td>
    <td><input id="computer-checkbox-{computer.id}" type="checkbox" bind:checked={computer.selected}  on:change={() => selectComputerAction()}/></td>
    {#if visibleColumns[0].visible}
        <td class="computerRow">
            <div style="display: inline-block;">
            {#if (computer.kiosk) && (computer.isDuplicate)}
                <i class="fad fa-desktop fa-sm font-weight-normal text-danger"></i>
            {:else if (computer.kiosk) && !(computer.isDuplicate)}
                <i class="fad fa-desktop fa-sm font-weight-normal"></i>
            {/if}
                <Link to="/ComputerDashboard/layout/{computer.id}/{computer.hostName}">{computer.hostName}</Link>
            <br/>             
            </div>
        </td>
    {/if}
    {#if visibleColumns[1].visible}
        <td>{computer.vesselName}</td>
    {/if}
    
    {#if visibleColumns[2].visible}
        <td><Tag color={tag.color} text={computer.deployVersion == "" ? "Unknown" : computer.deployVersion} icon={tag.icon}></Tag></td>
    {/if}
    {#if visibleColumns[3].visible}
        <td><i class="fad fa-circle text-{getLastReportedColour(computer.lastReportedState)}"></i> {formatDate(computer.lastReported)}</td>
    {/if}
    {#if visibleColumns[4].visible}
        <td>{Prettysize(computer.memoryCapacity)}</td>
    {/if}
    {#if visibleColumns[5].visible}
        <td>{computer.processor}</td>
    {/if}
    {#if visibleColumns[6].visible}
        <td>{computer.osName}</td>
    {/if}

    {#if visibleColumns[7].visible}
    <td>{computer.attributeCount}</td>
        {#if showAttributes}
            {#each uniqueAttributeNames as uniqueAttribute}                            
            {#if computer.attributes.filter(attr => attr.name == uniqueAttribute)}
                <td>
                {#each getAttributeValue(computer, uniqueAttribute) as attribute}
                    {attribute.value}<br>
                {/each}
                </td>
            {/if}    
            {/each}        
        {/if}
    {/if}
    <td>
    <Button id="delete-computer" on:click={() => deleteComputerAction()} color="primary" class="btn-plus btn-icon-split btn-sm" alt="Delete computer" title="Delete">
        <span class="icon text-white-50">
            <i class="fa fa-trash"style="vertical-align:auto !important;"></i>
        </span>
    </Button>
    </td>
</tr>
{#if isExpanded}
{#await getComputerDetails()}
{:then} 
     <tr>
        <td></td>
        <td colspan={visibleColumns.length + 3}>
        <div class="row container mr-4">
            <div class="col-sm">
                <h5 class="font-weight-bold text-primary">General</h5>
                <p class="m-0"><span class="font-weight-bold">Processor:</span> {computerDetails.processor}</p>
                <p class="m-0"><span class="font-weight-bold">Deploy Version:</span> {computerDetails.deployVersion}</p>
                <p class="m-0"><span class="font-weight-bold">Memory:</span> {Prettysize(computerDetails.memoryCapacity)}</p>
                <p class="m-0"><span class="font-weight-bold">Memory Type:</span> {computerDetails.memoryType}</p>
            </div>
            <div class="col-sm">
                <h5 class="font-weight-bold text-primary">Operating System</h5>
                <p class="m-0"><span class="font-weight-bold">Name:</span> {computerDetails.osName}</p>
                <p class="m-0"><span class="font-weight-bold">Build:</span> {computerDetails.osBuildNumber}</p>
                <p class="m-0"><span class="font-weight-bold">Architecture:</span> {computerDetails.osArchitecture}</p>
                <p class="m-0"><span class="font-weight-bold">Language:</span> {computerDetails.osLanguage}</p>
            </div>
            <div class="col-sm">
                <h5 class="font-weight-bold text-primary">Network</h5>
                <p class="m-0"><span class="font-weight-bold">DNS Host Name:</span> {computerDetails.dnsHostName}</p>
                <p class="m-0"><span class="font-weight-bold">Part Of Domain:</span> {computerDetails.partOfDomain}</p>
                <p class="m-0"><span class="font-weight-bold">Domain:</span> {computerDetails.domain}</p>
                <p class="m-0"><span class="font-weight-bold">Workgroup:</span> {computerDetails.workgroup}</p>
            </div>
        </div>
    </tr>
{/await}
{/if}  


<style>
  .dropdown-button {
    background-color: transparent;
    border-radius: 100%;
    cursor: pointer;
    height: 30px;
    width: 30px;
    border-color: transparent;
  }

  .dropdown-button:hover {
    background-color: var(--grey-300);
    transition: 0.1s;
  }

  .dropdown-button.active {
    background-color: var(--grey-300);
    border: 3px solid var(--grey-200);
  }
</style>